<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import AccountsAllComponent from './component.accounts.svelte'
    import AccountComponent from './component.account.svelte'
    import AccountUpdateComponent from './component.update.svelte'
    import AccountCreateComponent from './component.create.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Cuentas" subtitle="Consulta y gestión de cuentas" />
        <AccountsAllComponent all={true} />
    </div>
</View>

<ModalContainer id="account_modal" title="Cuenta" >
    <AccountComponent />
</ModalContainer>

<ModalContainer id="account_create_modal" title="Crear Cuenta" >
    <AccountCreateComponent />
</ModalContainer>

<ModalContainer id="account_update_modal" title="Cuenta" >
    <AccountUpdateComponent />
</ModalContainer>